import { useState, useContext, useEffect } from 'react';
import { StateContext } from '@/features/allHome/context/state.context';
import { each } from 'lodash';

const useStateConfig = () => {
  const stateContext = useContext(StateContext);

  useEffect(() => {}, []);

  const getNextEnabledState = ({ doReverse }) => {
    let next = stateContext.currentState;
    let indexModifier = doReverse ? -1 : 1;
    let index = stateContext.currentStateIndex;
    do {
      index = index + indexModifier;
      stateContext.setCurrentStateIndex(index);
      next = stateContext.config.pages[index];
    } while (!isStateEnabled(next) && index <= stateContext.config.pages.length);
    stateContext.setCurrentState(next);
  };

  const isStateEnabled = (state) => {
    if (!state) {
      return false;
    }
    if (!state.enableState) {
      return true;
    } // assume states are enabled by default
    switch (state.enableState.conditionType) {
      case 'includes':
        // TODO if returning false here, consider unsetting any answers saved from this state due to a previous visit to this state
        return (
          stateContext.answers[state.enableState.answersKey].length &&
          stateContext.answers[state.enableState.answersKey].every((v) => state.enableState.answerValueMatches?.includes(v))
        );
      case 'matches':
        return stateContext.answers[state.enableState.answersKey] == state.enableState.answerValueMatches;
      default:
        return true;
    }
  };

  const totalEnabledStates = (pages) => {
    let enabledCount = 0;
    if (!pages) {
      return false;
    }
    each(pages, (page) => {
      if (isStateEnabled(page) && !page.excludeFromPageCount) {
        enabledCount = enabledCount + 1;
      }
    });
    return enabledCount;
  };

  const hasAnyNextQuestionPage = () => {
    let index = stateContext.currentStateIndex;
    let pages = stateContext.config.pages;
    let hasNextPage = false;

    do {
      index = index + 1;
      if (pages[index]?.type == 'question') {
        hasNextPage = true;
      }
    } while (!hasNextPage && index < pages.length);
    return hasNextPage;
  };

  return {
    getNextEnabledState: getNextEnabledState,
    hasAnyNextQuestionPage: hasAnyNextQuestionPage,
    totalEnabledStates: totalEnabledStates
  };
};

export default useStateConfig;
